import { httpClient } from './http-client';
import type { ApiResponse } from './api.types';
import type { DatoContable, DatoContableInput } from '../../modelos/Configuracion';

export const cuentaContableService = {
  getAll: (empresaId: string): Promise<ApiResponse<DatoContable[]>> => {
    return httpClient.get('/dato-contables', { empresaId });
  },

  getById: (id: string): Promise<ApiResponse<DatoContable>> => {
    return httpClient.get(`/dato-contables/${id}`);
  },

  create: (data: DatoContableInput): Promise<ApiResponse<DatoContable>> => {
    return httpClient.post('/dato-contables', data);
  },

  update: (id: string, data: DatoContableInput): Promise<ApiResponse<DatoContable>> => {
    return httpClient.put(`/dato-contables/${id}`, data);
  },

  delete: (id: string): Promise<ApiResponse<void>> => {
    return httpClient.delete(`/dato-contables/${id}`);
  },
};